import { MantineSize } from "@mantine/core";
import Dropdown from "@ui/components/Dropdown/Dropdown";
import React, { FC, memo } from "react";
import { GridWrapper } from "../../registerVehicleWidgetStyle";
import { DropDownOption } from "@data/types";

type Props = {
  label?: string;
  labelId?: string;
  placeholder?: string;
  options?: DropDownOption[];
  size?: MantineSize;
  required?: true;
  withAsterisk?: true;
  disabled?: boolean;
  value?: string | null;
  onSelect?: (selectedValue: string | null) => void;
  onDropdownOpen?: () => void;
  headLabel: string;
  errorMessage?: string;
};

const VehicleFormDropdownMemo: FC<Props> = ({
  label = "",
  labelId = "",
  placeholder = "",
  options = [],
  size = "md",
  required,
  withAsterisk,
  disabled,
  value,
  onSelect,
  onDropdownOpen,
  headLabel,
  errorMessage,
}) => {
  return (
    <>
      <GridWrapper>
        <Dropdown
          value={value}
          required={required}
          withAsterisk={withAsterisk}
          label={label}
          placeholder={placeholder}
          options={options}
          size={size}
          disabled={disabled}
          onSelect={onSelect}
          onDropdownOpen={onDropdownOpen}
          errorMessage={errorMessage}
        />
      </GridWrapper>
    </>
  );
};

export const VehicleFormDropdown = memo(VehicleFormDropdownMemo);
